import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "@mui/material";
import { useMutation, useManualQuery, ClientContext } from "graphql-hooks";

import {
  Container,
  Card,
  CardContent,
  Grid,
  Typography,
  Divider,
  TextField,
  Radio,
  Checkbox,
  Tooltip,
  Button,
  IconButton,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  DialogContentText,
  makeStyles,
} from "@material-ui/core";
import Box from "@mui/material/Box";

import { DataGrid } from "@mui/x-data-grid";

import styled from "styled-components";

import penImg from "../../assets/icons/pen.png";
import trashImg from "../../assets/icons/trash.png";
import previewImg from "../../assets/icons/preview.png";
import publishImg from "../../assets/icons/publish.png";
import unpublishImg from "../../assets/icons/unpublish.png";

import Diversity1Icon from "@mui/icons-material/Diversity1";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import HowToRegOutlinedIcon from "@mui/icons-material/HowToRegOutlined";

import ActivitiesDialog from "./ActivitiesDialog.js";
import ResourcesDialog from "./ResourcesDialog.js";
import MemberAttendanceInfoDialog from "./MemberAttendanceInfoDialog.js";

import { REFRESH_TOKEN_MUTATION } from "../../graphQL/user_qry";

import { GET_TERM_DATA_BY_TERM_UUID } from "../../graphQL/term_qry";

import { TEAM_TERM_ALL_PERIODS_QUERY } from "../../graphQL/team_term_period_qry";
import { GET_TEAM_DATA_BY_UUID } from "../../graphQL/team_term_qry";

import { GET_ALL_TEAMS_QUERY } from "../../graphQL/team_qry";
import { GET_ALL_MEMBERS_IN_TEAM_TERM_QUERY } from "../../graphQL/team_term_member_qry";

import { project_url } from "../../constants/Data";

import Header from "./Header_ui.js";

const StyledTooltip = styled((props) => (
  <Tooltip
    classes={{ popper: props.className }}
    {...props}
    PopperProps={{
      popperOptions: {
        modifiers: {
          flip: { enabled: false },
          offset: {
            offset: "0px, -35px, 20px, -25px",
          },
        },
      },
    }}
  />
))`
  & .MuiTooltip-tooltip {
    display: flex;
    background: #757575;
    color: #fff;
    border-radius: 4px;
    font-size: 10px;
    font-weight: 500;
  }
`;

const useStyles = makeStyles((theme) => ({
  root: {
    marginRight: "8rem",
    textAlign: "center",
    padding: theme.spacing(2),
    paddingLeft: 0,
    paddingRight: 0,
    width: "1400px",
    paddingTop: "7rem",
    //  minWidth: "500px",
  },
  container: {
    padding: theme.spacing(4),
    paddingTop: 0,
    marginTop: "1rem",
    marginBottom: "5rem",
    overflow: "hidden",
    clear: "both",
    borderRadius: "8px",
    //height: "870px",
    backgroundColor: "#ffffff",
  },
  ComponentDragBox: {
    float: "left",
  },
  FormDropBox: {
    float: "left",
    marginLeft: "5rem",
    marginTop: ".5rem",
  },
  outlinedButtonStyle: {
    borderRadius: 8,
    width: "110px",
    padding: 0,
    height: "48px",
    textTransform: "none",
  },
  buttonStyle: {
    borderRadius: 4,
    width: "100px",
    padding: 0,
    color: "#fff",
    height: "34px",
    backgroundColor: "#0D47A1",
    textTransform: "none",
    // "&:active": {
    //   backgroundColor: "#765285",
    // },
    "&:hover": {
      backgroundColor: "#1E88E5",
    },
  },
  dataGridStyle: {
    "& .MuiDataGrid-columnHeader": {
      backgroundColor: "#99D4FF",
      color: "#0D47A1",
    },

    "&.MuiDataGrid-scrollbar MuiDataGrid-scrollbar--horizontal css-1rtad1": {
      position: "relative",
      display: "block",
    },
    "&.MuiDataGrid-root": {
      //  minWidth: 980,
      //  width:"100%"
      //  overflowX: 'scroll'
    },

    "& .MuiDataGrid-cell:focus-within": {
      outline: "none !important",
    },
    "& .MuiDataGrid-columnHeader:last-child .MuiDataGrid-columnSeparator": {
      display: "none",
    },
    "& .MuiDataGrid-columnHeaderTitle": {
      fontWeight: 700,
      fontSize: 14,
    },
  },
  dataGridFooterStyle: {
    height: 45,
    marginBottom: 0,
    display: "flex",
    alignItems: "center",
    backgroundColor: "#99D4FF",
  },
  dataGridFooterTextStyle: {
    color: "#0D47A1",
    fontSize: 14,
    fontWeight: 700,
    textAlign: "center",
    //marginLeft: 22,
  },
  card: {
    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
    border: "1px solid rgba(0, 0, 0, 0.1)",
    height: "165px",
    textAlign: "left",
    borderRadius: "8px",
  },
}));
const now = new Date();
const resourcesData = [
  {
    teamId: 1,
    members: [
      {
        memberId: 1,
        name: "David Johnson",
        role: "Product Owner",
        getMemberTermAttendance: [
          {
            id: "1",
            actualDate: "03/11/2025",
            attended: "No",
            desc: "",
            event: "Story Point checking",
            eventType: "General Activity",
            period: "Applicants Submission",
            scheduledDate: "03/11/2025",
          },
          {
            id: "2",
            actualDate: "04/24/2025",
            attended: "No",
            desc: "Team gathering to celebrate the end of the Sprint.",
            event: "Sprint Party",
            eventType: "General Activity",
            period: "Sprint Break",
            scheduledDate: "04/24/2025",
          },
        ],
      },
      {
        memberId: 2,
        name: "Susan Sanders",
        role: "Developer",
        getMemberTermAttendance: [
          {
            id: "1",
            actualDate: "03/11/2025",
            attended: "No",
            desc: "",
            event: "Story Point checking",
            eventType: "General Activity",
            period: "Applicants Submission",
            scheduledDate: "03/11/2025",
          },
          {
            id: "2",
            actualDate: "04/24/2025",
            attended: "No",
            desc: "Team gathering to celebrate the end of the Sprint.",
            event: "Sprint Party",
            eventType: "General Activity",
            period: "Sprint Break",
            scheduledDate: "04/24/2025",
          },
        ],
      },
      {
        memberId: 3,
        name: "Mary Smith",
        role: "Developer",
        getMemberTermAttendance: [
          {
            id: "1",
            actualDate: "03/11/2025",
            attended: "No",
            desc: "",
            event: "Story Point checking",
            eventType: "General Activity",
            period: "Applicants Submission",
            scheduledDate: "03/11/2025",
          },
          {
            id: "2",
            actualDate: "04/24/2025",
            attended: "No",
            desc: "Team gathering to celebrate the end of the Sprint.",
            event: "Sprint Party",
            eventType: "General Activity",
            period: "Sprint Break",
            scheduledDate: "04/24/2025",
          },
        ],
      },
    ],
    staff: [
      {
        staffId: 1,
        name: "Hooshyar",
        role: "Product Owner",
        getMemberTermAttendance: [
          {
            id: "1",
            actualDate: "03/11/2025",
            attended: "No",
            desc: "",
            event: "Story Point checking",
            eventType: "General Activity",
            period: "Applicants Submission",
            scheduledDate: "03/11/2025",
          },
          {
            id: "2",
            actualDate: "04/24/2025",
            attended: "No",
            desc: "Team gathering to celebrate the end of the Sprint.",
            event: "Sprint Party",
            eventType: "General Activity",
            period: "Sprint Break",
            scheduledDate: "04/24/2025",
          },
        ],
      },
      {
        staffId: 2,
        name: "Sandy",
        role: "Scrum Master",
        getMemberTermAttendance: [
          {
            id: "1",
            actualDate: "03/11/2025",
            attended: "No",
            desc: "",
            event: "Story Point checking",
            eventType: "General Activity",
            period: "Applicants Submission",
            scheduledDate: "03/11/2025",
          },
          {
            id: "2",
            actualDate: "04/24/2025",
            attended: "No",
            desc: "Team gathering to celebrate the end of the Sprint.",
            event: "Sprint Party",
            eventType: "General Activity",
            period: "Sprint Break",
            scheduledDate: "04/24/2025",
          },
        ],
      },
      {
        staffId: 3,
        name: "David",
        role: "Developer",
        getMemberTermAttendance: [
          {
            id: "1",
            actualDate: "03/11/2025",
            attended: "No",
            desc: "",
            event: "Story Point checking",
            eventType: "General Activity",
            period: "Applicants Submission",
            scheduledDate: "03/11/2025",
          },
          {
            id: "2",
            actualDate: "04/24/2025",
            attended: "No",
            desc: "Team gathering to celebrate the end of the Sprint.",
            event: "Sprint Party",
            eventType: "General Activity",
            period: "Sprint Break",
            scheduledDate: "04/24/2025",
          },
        ],
      },
    ],
  },
  {
    teamId: 2,
    members: [
      {
        memberId: 1,
        name: "David Johnson",
        role: "Product Owner",
        getMemberTermAttendance: [
          {
            id: "1",
            actualDate: "03/11/2025",
            attended: "No",
            desc: "",
            event: "Story Point checking",
            eventType: "General Activity",
            period: "Applicants Submission",
            scheduledDate: "03/11/2025",
          },
          {
            id: "2",
            actualDate: "04/24/2025",
            attended: "No",
            desc: "Team gathering to celebrate the end of the Sprint.",
            event: "Sprint Party",
            eventType: "General Activity",
            period: "Sprint Break",
            scheduledDate: "04/24/2025",
          },
        ],
      },
      {
        memberId: 2,
        name: "Susan Sanders",
        role: "Developer",
        getMemberTermAttendance: [
          {
            id: "1",
            actualDate: "03/11/2025",
            attended: "No",
            desc: "",
            event: "Story Point checking",
            eventType: "General Activity",
            period: "Applicants Submission",
            scheduledDate: "03/11/2025",
          },
          {
            id: "2",
            actualDate: "04/24/2025",
            attended: "No",
            desc: "Team gathering to celebrate the end of the Sprint.",
            event: "Sprint Party",
            eventType: "General Activity",
            period: "Sprint Break",
            scheduledDate: "04/24/2025",
          },
        ],
      },
      {
        memberId: 3,
        name: "Mary Smith",
        role: "Developer",
        getMemberTermAttendance: [
          {
            id: "1",
            actualDate: "03/11/2025",
            attended: "No",
            desc: "",
            event: "Story Point checking",
            eventType: "General Activity",
            period: "Applicants Submission",
            scheduledDate: "03/11/2025",
          },
          {
            id: "2",
            actualDate: "04/24/2025",
            attended: "No",
            desc: "Team gathering to celebrate the end of the Sprint.",
            event: "Sprint Party",
            eventType: "General Activity",
            period: "Sprint Break",
            scheduledDate: "04/24/2025",
          },
        ],
      },
    ],
    staff: [
      {
        staffId: 1,
        name: "Hooshyar",
        role: "Product Owner",
        getMemberTermAttendance: [
          {
            id: "1",
            actualDate: "03/11/2025",
            attended: "No",
            desc: "",
            event: "Story Point checking",
            eventType: "General Activity",
            period: "Applicants Submission",
            scheduledDate: "03/11/2025",
          },
          {
            id: "2",
            actualDate: "04/24/2025",
            attended: "No",
            desc: "Team gathering to celebrate the end of the Sprint.",
            event: "Sprint Party",
            eventType: "General Activity",
            period: "Sprint Break",
            scheduledDate: "04/24/2025",
          },
        ],
      },
      {
        staffId: 2,
        name: "Sandy",
        role: "Scrum Master",
        getMemberTermAttendance: [
          {
            id: "1",
            actualDate: "03/11/2025",
            attended: "No",
            desc: "",
            event: "Story Point checking",
            eventType: "General Activity",
            period: "Applicants Submission",
            scheduledDate: "03/11/2025",
          },
          {
            id: "2",
            actualDate: "04/24/2025",
            attended: "No",
            desc: "Team gathering to celebrate the end of the Sprint.",
            event: "Sprint Party",
            eventType: "General Activity",
            period: "Sprint Break",
            scheduledDate: "04/24/2025",
          },
        ],
      },
      {
        staffId: 3,
        name: "David",
        role: "Developer",
        getMemberTermAttendance: [
          {
            id: "1",
            actualDate: "03/11/2025",
            attended: "No",
            desc: "",
            event: "Story Point checking",
            eventType: "General Activity",
            period: "Applicants Submission",
            scheduledDate: "03/11/2025",
          },
          {
            id: "2",
            actualDate: "04/24/2025",
            attended: "No",
            desc: "Team gathering to celebrate the end of the Sprint.",
            event: "Sprint Party",
            eventType: "General Activity",
            period: "Sprint Break",
            scheduledDate: "04/24/2025",
          },
        ],
      },
    ],
  },
  {
    teamId: 3,
    members: [
      {
        memberId: 1,
        name: "David Johnson",
        role: "Product Owner",
        getMemberTermAttendance: [
          {
            id: "1",
            actualDate: "03/11/2025",
            attended: "No",
            desc: "",
            event: "Story Point checking",
            eventType: "General Activity",
            period: "Applicants Submission",
            scheduledDate: "03/11/2025",
          },
          {
            id: "2",
            actualDate: "04/24/2025",
            attended: "No",
            desc: "Team gathering to celebrate the end of the Sprint.",
            event: "Sprint Party",
            eventType: "General Activity",
            period: "Sprint Break",
            scheduledDate: "04/24/2025",
          },
        ],
      },
      {
        memberId: 2,
        name: "Susan Sanders",
        role: "Developer",
        getMemberTermAttendance: [
          {
            id: "1",
            actualDate: "03/11/2025",
            attended: "No",
            desc: "",
            event: "Story Point checking",
            eventType: "General Activity",
            period: "Applicants Submission",
            scheduledDate: "03/11/2025",
          },
          {
            id: "2",
            actualDate: "04/24/2025",
            attended: "No",
            desc: "Team gathering to celebrate the end of the Sprint.",
            event: "Sprint Party",
            eventType: "General Activity",
            period: "Sprint Break",
            scheduledDate: "04/24/2025",
          },
        ],
      },
      {
        memberId: 3,
        name: "Mary Smith",
        role: "Developer",
        getMemberTermAttendance: [
          {
            id: "1",
            actualDate: "03/11/2025",
            attended: "No",
            desc: "",
            event: "Story Point checking",
            eventType: "General Activity",
            period: "Applicants Submission",
            scheduledDate: "03/11/2025",
          },
          {
            id: "2",
            actualDate: "04/24/2025",
            attended: "No",
            desc: "Team gathering to celebrate the end of the Sprint.",
            event: "Sprint Party",
            eventType: "General Activity",
            period: "Sprint Break",
            scheduledDate: "04/24/2025",
          },
        ],
      },
      {
        memberId: 4,
        name: "Don Song",
        role: "Product Owner",
        getMemberTermAttendance: [
          {
            id: "1",
            actualDate: "03/11/2025",
            attended: "No",
            desc: "",
            event: "Story Point checking",
            eventType: "General Activity",
            period: "Applicants Submission",
            scheduledDate: "03/11/2025",
          },
          {
            id: "2",
            actualDate: "04/24/2025",
            attended: "No",
            desc: "Team gathering to celebrate the end of the Sprint.",
            event: "Sprint Party",
            eventType: "General Activity",
            period: "Sprint Break",
            scheduledDate: "04/24/2025",
          },
        ],
      },
      {
        memberId: 5,
        name: "Joseph Foo",
        role: "Scrum Master",
        getMemberTermAttendance: [
          {
            id: "1",
            actualDate: "03/11/2025",
            attended: "No",
            desc: "",
            event: "Story Point checking",
            eventType: "General Activity",
            period: "Applicants Submission",
            scheduledDate: "03/11/2025",
          },
          {
            id: "2",
            actualDate: "04/24/2025",
            attended: "No",
            desc: "Team gathering to celebrate the end of the Sprint.",
            event: "Sprint Party",
            eventType: "General Activity",
            period: "Sprint Break",
            scheduledDate: "04/24/2025",
          },
        ],
      },
    ],
    staff: [
      {
        staffId: 1,
        name: "Hooshyar",
        role: "Product Owner",
        getMemberTermAttendance: [
          {
            id: "1",
            actualDate: "03/11/2025",
            attended: "No",
            desc: "",
            event: "Story Point checking",
            eventType: "General Activity",
            period: "Applicants Submission",
            scheduledDate: "03/11/2025",
          },
          {
            id: "2",
            actualDate: "04/24/2025",
            attended: "No",
            desc: "Team gathering to celebrate the end of the Sprint.",
            event: "Sprint Party",
            eventType: "General Activity",
            period: "Sprint Break",
            scheduledDate: "04/24/2025",
          },
        ],
      },
      {
        staffId: 2,
        name: "Sandy",
        role: "Scrum Master",
        getMemberTermAttendance: [
          {
            id: "1",
            actualDate: "03/11/2025",
            attended: "No",
            desc: "",
            event: "Story Point checking",
            eventType: "General Activity",
            period: "Applicants Submission",
            scheduledDate: "03/11/2025",
          },
          {
            id: "2",
            actualDate: "04/24/2025",
            attended: "No",
            desc: "Team gathering to celebrate the end of the Sprint.",
            event: "Sprint Party",
            eventType: "General Activity",
            period: "Sprint Break",
            scheduledDate: "04/24/2025",
          },
        ],
      },
      {
        staffId: 3,
        name: "David",
        role: "Developer",
        getMemberTermAttendance: [
          {
            id: "1",
            actualDate: "03/11/2025",
            attended: "No",
            desc: "",
            event: "Story Point checking",
            eventType: "General Activity",
            period: "Applicants Submission",
            scheduledDate: "03/11/2025",
          },
          {
            id: "2",
            actualDate: "04/24/2025",
            attended: "No",
            desc: "Team gathering to celebrate the end of the Sprint.",
            event: "Sprint Party",
            eventType: "General Activity",
            period: "Sprint Break",
            scheduledDate: "04/24/2025",
          },
        ],
      },
      {
        staffId: 4,
        name: "Rose",
        role: "Scrum Master",
        getMemberTermAttendance: [
          {
            id: "1",
            actualDate: "03/11/2025",
            attended: "No",
            desc: "",
            event: "Story Point checking",
            eventType: "General Activity",
            period: "Applicants Submission",
            scheduledDate: "03/11/2025",
          },
          {
            id: "2",
            actualDate: "04/24/2025",
            attended: "No",
            desc: "Team gathering to celebrate the end of the Sprint.",
            event: "Sprint Party",
            eventType: "General Activity",
            period: "Sprint Break",
            scheduledDate: "04/24/2025",
          },
        ],
      },
      {
        staffId: 5,
        name: "Robinia",
        role: "Developer",
        getMemberTermAttendance: [
          {
            id: "1",
            actualDate: "03/11/2025",
            attended: "No",
            desc: "",
            event: "Story Point checking",
            eventType: "General Activity",
            period: "Applicants Submission",
            scheduledDate: "03/11/2025",
          },
          {
            id: "2",
            actualDate: "04/24/2025",
            attended: "No",
            desc: "Team gathering to celebrate the end of the Sprint.",
            event: "Sprint Party",
            eventType: "General Activity",
            period: "Sprint Break",
            scheduledDate: "04/24/2025",
          },
        ],
      },
    ],
  },
  {
    teamId: 4,
    members: [
      {
        memberId: 3,
        name: "Mary Smith",
        role: "Developer",
        getMemberTermAttendance: [
          {
            id: "1",
            actualDate: "03/11/2025",
            attended: "Yes",
            desc: "",
            event: "Story Point checking",
            eventType: "General Activity",
            period: "Applicants Submission",
            scheduledDate: "03/11/2025",
          },
          {
            id: "2",
            actualDate: "04/24/2025",
            attended: "No",
            desc: "Team gathering to celebrate the end of the Sprint.",
            event: "Sprint Party",
            eventType: "General Activity",
            period: "Sprint Break",
            scheduledDate: "04/24/2025",
          },
        ],
      },
      {
        memberId: 4,
        name: "Don Song",
        role: "Product Owner",
        getMemberTermAttendance: [
          {
            id: "1",
            actualDate: "03/11/2025",
            attended: "No",
            desc: "",
            event: "Story Point checking",
            eventType: "General Activity",
            period: "Applicants Submission",
            scheduledDate: "03/11/2025",
          },
          {
            id: "2",
            actualDate: "04/24/2025",
            attended: "No",
            desc: "Team gathering to celebrate the end of the Sprint.",
            event: "Sprint Party",
            eventType: "General Activity",
            period: "Sprint Break",
            scheduledDate: "04/24/2025",
          },
        ],
      },
      {
        memberId: 5,
        name: "Joseph Foo",
        role: "Scrum Master",
        getMemberTermAttendance: [
          {
            id: "1",
            actualDate: "03/11/2025",
            attended: "No",
            desc: "",
            event: "Story Point checking",
            eventType: "General Activity",
            period: "Applicants Submission",
            scheduledDate: "03/11/2025",
          },
          {
            id: "2",
            actualDate: "04/24/2025",
            attended: "No",
            desc: "Team gathering to celebrate the end of the Sprint.",
            event: "Sprint Party",
            eventType: "General Activity",
            period: "Sprint Break",
            scheduledDate: "04/24/2025",
          },
        ],
      },
    ],
    staff: [
      {
        staffId: 2,
        name: "Sandy",
        role: "Scrum Master",
        getMemberTermAttendance: [
          {
            id: "1",
            actualDate: "03/11/2025",
            attended: "No",
            desc: "",
            event: "Story Point checking",
            eventType: "General Activity",
            period: "Applicants Submission",
            scheduledDate: "03/11/2025",
          },
          {
            id: "2",
            actualDate: "04/24/2025",
            attended: "No",
            desc: "Team gathering to celebrate the end of the Sprint.",
            event: "Sprint Party",
            eventType: "General Activity",
            period: "Sprint Break",
            scheduledDate: "04/24/2025",
          },
        ],
      },
      {
        staffId: 3,
        name: "David",
        role: "Developer",
        getMemberTermAttendance: [
          {
            id: "1",
            actualDate: "03/11/2025",
            attended: "No",
            desc: "",
            event: "Story Point checking",
            eventType: "General Activity",
            period: "Applicants Submission",
            scheduledDate: "03/11/2025",
          },
          {
            id: "2",
            actualDate: "04/24/2025",
            attended: "No",
            desc: "Team gathering to celebrate the end of the Sprint.",
            event: "Sprint Party",
            eventType: "General Activity",
            period: "Sprint Break",
            scheduledDate: "04/24/2025",
          },
        ],
      },
      {
        staffId: 4,
        name: "Rose",
        role: "Scrum Master",
        getMemberTermAttendance: [
          {
            id: "1",
            actualDate: "03/11/2025",
            attended: "No",
            desc: "",
            event: "Story Point checking",
            eventType: "General Activity",
            period: "Applicants Submission",
            scheduledDate: "03/11/2025",
          },
          {
            id: "2",
            actualDate: "04/24/2025",
            attended: "No",
            desc: "Team gathering to celebrate the end of the Sprint.",
            event: "Sprint Party",
            eventType: "General Activity",
            period: "Sprint Break",
            scheduledDate: "04/24/2025",
          },
        ],
      },
      {
        staffId: 5,
        name: "Robinia",
        role: "Developer",
        getMemberTermAttendance: [
          {
            id: "1",
            actualDate: "03/11/2025",
            attended: "No",
            desc: "",
            event: "Story Point checking",
            eventType: "General Activity",
            period: "Applicants Submission",
            scheduledDate: "03/11/2025",
          },
          {
            id: "2",
            actualDate: "04/24/2025",
            attended: "No",
            desc: "Team gathering to celebrate the end of the Sprint.",
            event: "Sprint Party",
            eventType: "General Activity",
            period: "Sprint Break",
            scheduledDate: "04/24/2025",
          },
        ],
      },
    ],
  },
  {
    teamId: 5,
    members: [
      {
        memberId: 1,
        name: "David Johnson",
        role: "Product Owner",
        getMemberTermAttendance: [
          {
            id: "1",
            actualDate: "03/11/2025",
            attended: "No",
            desc: "",
            event: "Story Point checking",
            eventType: "General Activity",
            period: "Applicants Submission",
            scheduledDate: "03/11/2025",
          },
          {
            id: "2",
            actualDate: "04/24/2025",
            attended: "No",
            desc: "Team gathering to celebrate the end of the Sprint.",
            event: "Sprint Party",
            eventType: "General Activity",
            period: "Sprint Break",
            scheduledDate: "04/24/2025",
          },
        ],
      },
      {
        memberId: 2,
        name: "Susan Sanders",
        role: "Developer",
        getMemberTermAttendance: [
          {
            id: "1",
            actualDate: "03/11/2025",
            attended: "No",
            desc: "",
            event: "Story Point checking",
            eventType: "General Activity",
            period: "Applicants Submission",
            scheduledDate: "03/11/2025",
          },
          {
            id: "2",
            actualDate: "04/24/2025",
            attended: "No",
            desc: "Team gathering to celebrate the end of the Sprint.",
            event: "Sprint Party",
            eventType: "General Activity",
            period: "Sprint Break",
            scheduledDate: "04/24/2025",
          },
        ],
      },
      {
        memberId: 3,
        name: "Mary Smith",
        role: "Developer",
        getMemberTermAttendance: [
          {
            id: "1",
            actualDate: "03/11/2025",
            attended: "No",
            desc: "",
            event: "Story Point checking",
            eventType: "General Activity",
            period: "Applicants Submission",
            scheduledDate: "03/11/2025",
          },
          {
            id: "2",
            actualDate: "04/24/2025",
            attended: "No",
            desc: "Team gathering to celebrate the end of the Sprint.",
            event: "Sprint Party",
            eventType: "General Activity",
            period: "Sprint Break",
            scheduledDate: "04/24/2025",
          },
        ],
      },
      {
        memberId: 4,
        name: "Don Song",
        role: "Product Owner",
        getMemberTermAttendance: [
          {
            id: "1",
            actualDate: "03/11/2025",
            attended: "No",
            desc: "",
            event: "Story Point checking",
            eventType: "General Activity",
            period: "Applicants Submission",
            scheduledDate: "03/11/2025",
          },
          {
            id: "2",
            actualDate: "04/24/2025",
            attended: "No",
            desc: "Team gathering to celebrate the end of the Sprint.",
            event: "Sprint Party",
            eventType: "General Activity",
            period: "Sprint Break",
            scheduledDate: "04/24/2025",
          },
        ],
      },
      {
        memberId: 5,
        name: "Joseph Foo",
        role: "Scrum Master",
        getMemberTermAttendance: [
          {
            id: "1",
            actualDate: "03/11/2025",
            attended: "No",
            desc: "",
            event: "Story Point checking",
            eventType: "General Activity",
            period: "Applicants Submission",
            scheduledDate: "03/11/2025",
          },
          {
            id: "2",
            actualDate: "04/24/2025",
            attended: "No",
            desc: "Team gathering to celebrate the end of the Sprint.",
            event: "Sprint Party",
            eventType: "General Activity",
            period: "Sprint Break",
            scheduledDate: "04/24/2025",
          },
        ],
      },
    ],
    staff: [
      {
        staffId: 1,
        name: "Hooshyar",
        role: "Product Owner",
        getMemberTermAttendance: [
          {
            id: "1",
            actualDate: "03/11/2025",
            attended: "No",
            desc: "",
            event: "Story Point checking",
            eventType: "General Activity",
            period: "Applicants Submission",
            scheduledDate: "03/11/2025",
          },
          {
            id: "2",
            actualDate: "04/24/2025",
            attended: "No",
            desc: "Team gathering to celebrate the end of the Sprint.",
            event: "Sprint Party",
            eventType: "General Activity",
            period: "Sprint Break",
            scheduledDate: "04/24/2025",
          },
        ],
      },
      {
        staffId: 2,
        name: "Sandy",
        role: "Scrum Master",
        getMemberTermAttendance: [
          {
            id: "1",
            actualDate: "03/11/2025",
            attended: "No",
            desc: "",
            event: "Story Point checking",
            eventType: "General Activity",
            period: "Applicants Submission",
            scheduledDate: "03/11/2025",
          },
          {
            id: "2",
            actualDate: "04/24/2025",
            attended: "No",
            desc: "Team gathering to celebrate the end of the Sprint.",
            event: "Sprint Party",
            eventType: "General Activity",
            period: "Sprint Break",
            scheduledDate: "04/24/2025",
          },
        ],
      },
      {
        staffId: 3,
        name: "David",
        role: "Developer",
        getMemberTermAttendance: [
          {
            id: "1",
            actualDate: "03/11/2025",
            attended: "No",
            desc: "",
            event: "Story Point checking",
            eventType: "General Activity",
            period: "Applicants Submission",
            scheduledDate: "03/11/2025",
          },
          {
            id: "2",
            actualDate: "04/24/2025",
            attended: "No",
            desc: "Team gathering to celebrate the end of the Sprint.",
            event: "Sprint Party",
            eventType: "General Activity",
            period: "Sprint Break",
            scheduledDate: "04/24/2025",
          },
        ],
      },
      {
        staffId: 4,
        name: "Rose",
        role: "Scrum Master",
        getMemberTermAttendance: [
          {
            id: "1",
            actualDate: "03/11/2025",
            attended: "No",
            desc: "",
            event: "Story Point checking",
            eventType: "General Activity",
            period: "Applicants Submission",
            scheduledDate: "03/11/2025",
          },
          {
            id: "2",
            actualDate: "04/24/2025",
            attended: "No",
            desc: "Team gathering to celebrate the end of the Sprint.",
            event: "Sprint Party",
            eventType: "General Activity",
            period: "Sprint Break",
            scheduledDate: "04/24/2025",
          },
        ],
      },
      {
        staffId: 5,
        name: "Robinia",
        role: "Developer",
        getMemberTermAttendance: [
          {
            id: "1",
            actualDate: "03/11/2025",
            attended: "No",
            desc: "",
            event: "Story Point checking",
            eventType: "General Activity",
            period: "Applicants Submission",
            scheduledDate: "03/11/2025",
          },
          {
            id: "2",
            actualDate: "04/24/2025",
            attended: "No",
            desc: "Team gathering to celebrate the end of the Sprint.",
            event: "Sprint Party",
            eventType: "General Activity",
            period: "Sprint Break",
            scheduledDate: "04/24/2025",
          },
        ],
      },
    ],
  },
  {
    teamId: 6,
    members: [
      {
        memberId: 1,
        name: "David Johnson",
        role: "Product Owner",
        getMemberTermAttendance: [
          {
            id: "1",
            actualDate: "03/11/2025",
            attended: "No",
            desc: "",
            event: "Story Point checking",
            eventType: "General Activity",
            period: "Applicants Submission",
            scheduledDate: "03/11/2025",
          },
          {
            id: "2",
            actualDate: "04/24/2025",
            attended: "No",
            desc: "Team gathering to celebrate the end of the Sprint.",
            event: "Sprint Party",
            eventType: "General Activity",
            period: "Sprint Break",
            scheduledDate: "04/24/2025",
          },
        ],
      },
      {
        memberId: 2,
        name: "Susan Sanders",
        role: "Developer",
        getMemberTermAttendance: [
          {
            id: "1",
            actualDate: "03/11/2025",
            attended: "No",
            desc: "",
            event: "Story Point checking",
            eventType: "General Activity",
            period: "Applicants Submission",
            scheduledDate: "03/11/2025",
          },
          {
            id: "2",
            actualDate: "04/24/2025",
            attended: "No",
            desc: "Team gathering to celebrate the end of the Sprint.",
            event: "Sprint Party",
            eventType: "General Activity",
            period: "Sprint Break",
            scheduledDate: "04/24/2025",
          },
        ],
      },
      {
        memberId: 3,
        name: "Mary Smith",
        role: "Developer",
        getMemberTermAttendance: [
          {
            id: "1",
            actualDate: "03/11/2025",
            attended: "No",
            desc: "",
            event: "Story Point checking",
            eventType: "General Activity",
            period: "Applicants Submission",
            scheduledDate: "03/11/2025",
          },
          {
            id: "2",
            actualDate: "04/24/2025",
            attended: "No",
            desc: "Team gathering to celebrate the end of the Sprint.",
            event: "Sprint Party",
            eventType: "General Activity",
            period: "Sprint Break",
            scheduledDate: "04/24/2025",
          },
        ],
      },
      {
        memberId: 4,
        name: "Don Song",
        role: "Product Owner",
        getMemberTermAttendance: [
          {
            id: "1",
            actualDate: "03/11/2025",
            attended: "No",
            desc: "",
            event: "Story Point checking",
            eventType: "General Activity",
            period: "Applicants Submission",
            scheduledDate: "03/11/2025",
          },
          {
            id: "2",
            actualDate: "04/24/2025",
            attended: "No",
            desc: "Team gathering to celebrate the end of the Sprint.",
            event: "Sprint Party",
            eventType: "General Activity",
            period: "Sprint Break",
            scheduledDate: "04/24/2025",
          },
        ],
      },
      {
        memberId: 5,
        name: "Joseph Foo",
        role: "Scrum Master",
        getMemberTermAttendance: [
          {
            id: "1",
            actualDate: "03/11/2025",
            attended: "No",
            desc: "",
            event: "Story Point checking",
            eventType: "General Activity",
            period: "Applicants Submission",
            scheduledDate: "03/11/2025",
          },
          {
            id: "2",
            actualDate: "04/24/2025",
            attended: "No",
            desc: "Team gathering to celebrate the end of the Sprint.",
            event: "Sprint Party",
            eventType: "General Activity",
            period: "Sprint Break",
            scheduledDate: "04/24/2025",
          },
        ],
      },
    ],
    staff: [
      {
        staffId: 1,
        name: "Hooshyar",
        role: "Product Owner",
        getMemberTermAttendance: [
          {
            id: "1",
            actualDate: "03/11/2025",
            attended: "No",
            desc: "",
            event: "Story Point checking",
            eventType: "General Activity",
            period: "Applicants Submission",
            scheduledDate: "03/11/2025",
          },
          {
            id: "2",
            actualDate: "04/24/2025",
            attended: "No",
            desc: "Team gathering to celebrate the end of the Sprint.",
            event: "Sprint Party",
            eventType: "General Activity",
            period: "Sprint Break",
            scheduledDate: "04/24/2025",
          },
        ],
      },
      {
        staffId: 2,
        name: "Sandy",
        role: "Scrum Master",
        getMemberTermAttendance: [
          {
            id: "1",
            actualDate: "03/11/2025",
            attended: "No",
            desc: "",
            event: "Story Point checking",
            eventType: "General Activity",
            period: "Applicants Submission",
            scheduledDate: "03/11/2025",
          },
          {
            id: "2",
            actualDate: "04/24/2025",
            attended: "No",
            desc: "Team gathering to celebrate the end of the Sprint.",
            event: "Sprint Party",
            eventType: "General Activity",
            period: "Sprint Break",
            scheduledDate: "04/24/2025",
          },
        ],
      },
      {
        staffId: 3,
        name: "David",
        role: "Developer",
        getMemberTermAttendance: [
          {
            id: "1",
            actualDate: "03/11/2025",
            attended: "No",
            desc: "",
            event: "Story Point checking",
            eventType: "General Activity",
            period: "Applicants Submission",
            scheduledDate: "03/11/2025",
          },
          {
            id: "2",
            actualDate: "04/24/2025",
            attended: "No",
            desc: "Team gathering to celebrate the end of the Sprint.",
            event: "Sprint Party",
            eventType: "General Activity",
            period: "Sprint Break",
            scheduledDate: "04/24/2025",
          },
        ],
      },
      {
        staffId: 4,
        name: "Rose",
        role: "Scrum Master",
        getMemberTermAttendance: [
          {
            id: "1",
            actualDate: "03/11/2025",
            attended: "No",
            desc: "",
            event: "Story Point checking",
            eventType: "General Activity",
            period: "Applicants Submission",
            scheduledDate: "03/11/2025",
          },
          {
            id: "2",
            actualDate: "04/24/2025",
            attended: "No",
            desc: "Team gathering to celebrate the end of the Sprint.",
            event: "Sprint Party",
            eventType: "General Activity",
            period: "Sprint Break",
            scheduledDate: "04/24/2025",
          },
        ],
      },
      {
        staffId: 5,
        name: "Robinia",
        role: "Developer",
        getMemberTermAttendance: [
          {
            id: "1",
            actualDate: "03/11/2025",
            attended: "No",
            desc: "",
            event: "Story Point checking",
            eventType: "General Activity",
            period: "Applicants Submission",
            scheduledDate: "03/11/2025",
          },
          {
            id: "2",
            actualDate: "04/24/2025",
            attended: "No",
            desc: "Team gathering to celebrate the end of the Sprint.",
            event: "Sprint Party",
            eventType: "General Activity",
            period: "Sprint Break",
            scheduledDate: "04/24/2025",
          },
        ],
      },
    ],
  },
  {
    teamId: 7,
    members: [
      {
        memberId: 1,
        name: "David Johnson",
        role: "Product Owner",
        getMemberTermAttendance: [
          {
            id: "1",
            actualDate: "03/11/2025",
            attended: "No",
            desc: "",
            event: "Story Point checking",
            eventType: "General Activity",
            period: "Applicants Submission",
            scheduledDate: "03/11/2025",
          },
          {
            id: "2",
            actualDate: "04/24/2025",
            attended: "No",
            desc: "Team gathering to celebrate the end of the Sprint.",
            event: "Sprint Party",
            eventType: "General Activity",
            period: "Sprint Break",
            scheduledDate: "04/24/2025",
          },
        ],
      },
      {
        memberId: 2,
        name: "Susan Sanders",
        role: "Developer",
        getMemberTermAttendance: [
          {
            id: "1",
            actualDate: "03/11/2025",
            attended: "No",
            desc: "",
            event: "Story Point checking",
            eventType: "General Activity",
            period: "Applicants Submission",
            scheduledDate: "03/11/2025",
          },
          {
            id: "2",
            actualDate: "04/24/2025",
            attended: "No",
            desc: "Team gathering to celebrate the end of the Sprint.",
            event: "Sprint Party",
            eventType: "General Activity",
            period: "Sprint Break",
            scheduledDate: "04/24/2025",
          },
        ],
      },
      {
        memberId: 3,
        name: "Mary Smith",
        role: "Developer",
        getMemberTermAttendance: [
          {
            id: "1",
            actualDate: "03/11/2025",
            attended: "No",
            desc: "",
            event: "Story Point checking",
            eventType: "General Activity",
            period: "Applicants Submission",
            scheduledDate: "03/11/2025",
          },
          {
            id: "2",
            actualDate: "04/24/2025",
            attended: "No",
            desc: "Team gathering to celebrate the end of the Sprint.",
            event: "Sprint Party",
            eventType: "General Activity",
            period: "Sprint Break",
            scheduledDate: "04/24/2025",
          },
        ],
      },
      {
        memberId: 4,
        name: "Don Song",
        role: "Product Owner",
        getMemberTermAttendance: [
          {
            id: "1",
            actualDate: "03/11/2025",
            attended: "No",
            desc: "",
            event: "Story Point checking",
            eventType: "General Activity",
            period: "Applicants Submission",
            scheduledDate: "03/11/2025",
          },
          {
            id: "2",
            actualDate: "04/24/2025",
            attended: "No",
            desc: "Team gathering to celebrate the end of the Sprint.",
            event: "Sprint Party",
            eventType: "General Activity",
            period: "Sprint Break",
            scheduledDate: "04/24/2025",
          },
        ],
      },
      {
        memberId: 5,
        name: "Joseph Foo",
        role: "Scrum Master",
        getMemberTermAttendance: [
          {
            id: "1",
            actualDate: "03/11/2025",
            attended: "No",
            desc: "",
            event: "Story Point checking",
            eventType: "General Activity",
            period: "Applicants Submission",
            scheduledDate: "03/11/2025",
          },
          {
            id: "2",
            actualDate: "04/24/2025",
            attended: "No",
            desc: "Team gathering to celebrate the end of the Sprint.",
            event: "Sprint Party",
            eventType: "General Activity",
            period: "Sprint Break",
            scheduledDate: "04/24/2025",
          },
        ],
      },
    ],
    staff: [
      {
        staffId: 1,
        name: "Hooshyar",
        role: "Product Owner",
        getMemberTermAttendance: [
          {
            id: "1",
            actualDate: "03/11/2025",
            attended: "No",
            desc: "",
            event: "Story Point checking",
            eventType: "General Activity",
            period: "Applicants Submission",
            scheduledDate: "03/11/2025",
          },
          {
            id: "2",
            actualDate: "04/24/2025",
            attended: "No",
            desc: "Team gathering to celebrate the end of the Sprint.",
            event: "Sprint Party",
            eventType: "General Activity",
            period: "Sprint Break",
            scheduledDate: "04/24/2025",
          },
        ],
      },
      {
        staffId: 2,
        name: "Sandy",
        role: "Scrum Master",
        getMemberTermAttendance: [
          {
            id: "1",
            actualDate: "03/11/2025",
            attended: "No",
            desc: "",
            event: "Story Point checking",
            eventType: "General Activity",
            period: "Applicants Submission",
            scheduledDate: "03/11/2025",
          },
          {
            id: "2",
            actualDate: "04/24/2025",
            attended: "No",
            desc: "Team gathering to celebrate the end of the Sprint.",
            event: "Sprint Party",
            eventType: "General Activity",
            period: "Sprint Break",
            scheduledDate: "04/24/2025",
          },
        ],
      },
      {
        staffId: 3,
        name: "David",
        role: "Developer",
        getMemberTermAttendance: [
          {
            id: "1",
            actualDate: "03/11/2025",
            attended: "No",
            desc: "",
            event: "Story Point checking",
            eventType: "General Activity",
            period: "Applicants Submission",
            scheduledDate: "03/11/2025",
          },
          {
            id: "2",
            actualDate: "04/24/2025",
            attended: "No",
            desc: "Team gathering to celebrate the end of the Sprint.",
            event: "Sprint Party",
            eventType: "General Activity",
            period: "Sprint Break",
            scheduledDate: "04/24/2025",
          },
        ],
      },
      {
        staffId: 4,
        name: "Rose",
        role: "Scrum Master",
        getMemberTermAttendance: [
          {
            id: "1",
            actualDate: "03/11/2025",
            attended: "No",
            desc: "",
            event: "Story Point checking",
            eventType: "General Activity",
            period: "Applicants Submission",
            scheduledDate: "03/11/2025",
          },
          {
            id: "2",
            actualDate: "04/24/2025",
            attended: "No",
            desc: "Team gathering to celebrate the end of the Sprint.",
            event: "Sprint Party",
            eventType: "General Activity",
            period: "Sprint Break",
            scheduledDate: "04/24/2025",
          },
        ],
      },
      {
        staffId: 5,
        name: "Robinia",
        role: "Developer",
        getMemberTermAttendance: [
          {
            id: "1",
            actualDate: "03/11/2025",
            attended: "No",
            desc: "",
            event: "Story Point checking",
            eventType: "General Activity",
            period: "Applicants Submission",
            scheduledDate: "03/11/2025",
          },
          {
            id: "2",
            actualDate: "04/24/2025",
            attended: "No",
            desc: "Team gathering to celebrate the end of the Sprint.",
            event: "Sprint Party",
            eventType: "General Activity",
            period: "Sprint Break",
            scheduledDate: "04/24/2025",
          },
        ],
      },
    ],
  },
  {
    teamId: 8,
    members: [
      {
        memberId: 1,
        name: "David Johnson",
        role: "Product Owner",
        getMemberTermAttendance: [
          {
            id: "1",
            actualDate: "03/11/2025",
            attended: "No",
            desc: "",
            event: "Story Point checking",
            eventType: "General Activity",
            period: "Applicants Submission",
            scheduledDate: "03/11/2025",
          },
          {
            id: "2",
            actualDate: "04/24/2025",
            attended: "No",
            desc: "Team gathering to celebrate the end of the Sprint.",
            event: "Sprint Party",
            eventType: "General Activity",
            period: "Sprint Break",
            scheduledDate: "04/24/2025",
          },
        ],
      },
      {
        memberId: 2,
        name: "Susan Sanders",
        role: "Developer",
        getMemberTermAttendance: [
          {
            id: "1",
            actualDate: "03/11/2025",
            attended: "No",
            desc: "",
            event: "Story Point checking",
            eventType: "General Activity",
            period: "Applicants Submission",
            scheduledDate: "03/11/2025",
          },
          {
            id: "2",
            actualDate: "04/24/2025",
            attended: "No",
            desc: "Team gathering to celebrate the end of the Sprint.",
            event: "Sprint Party",
            eventType: "General Activity",
            period: "Sprint Break",
            scheduledDate: "04/24/2025",
          },
        ],
      },
      {
        memberId: 3,
        name: "Mary Smith",
        role: "Developer",
        getMemberTermAttendance: [
          {
            id: "1",
            actualDate: "03/11/2025",
            attended: "No",
            desc: "",
            event: "Story Point checking",
            eventType: "General Activity",
            period: "Applicants Submission",
            scheduledDate: "03/11/2025",
          },
          {
            id: "2",
            actualDate: "04/24/2025",
            attended: "No",
            desc: "Team gathering to celebrate the end of the Sprint.",
            event: "Sprint Party",
            eventType: "General Activity",
            period: "Sprint Break",
            scheduledDate: "04/24/2025",
          },
        ],
      },
      {
        memberId: 4,
        name: "Don Song",
        role: "Product Owner",
        getMemberTermAttendance: [
          {
            id: "1",
            actualDate: "03/11/2025",
            attended: "No",
            desc: "",
            event: "Story Point checking",
            eventType: "General Activity",
            period: "Applicants Submission",
            scheduledDate: "03/11/2025",
          },
          {
            id: "2",
            actualDate: "04/24/2025",
            attended: "No",
            desc: "Team gathering to celebrate the end of the Sprint.",
            event: "Sprint Party",
            eventType: "General Activity",
            period: "Sprint Break",
            scheduledDate: "04/24/2025",
          },
        ],
      },
      {
        memberId: 5,
        name: "Joseph Foo",
        role: "Scrum Master",
        getMemberTermAttendance: [
          {
            id: "1",
            actualDate: "03/11/2025",
            attended: "No",
            desc: "",
            event: "Story Point checking",
            eventType: "General Activity",
            period: "Applicants Submission",
            scheduledDate: "03/11/2025",
          },
          {
            id: "2",
            actualDate: "04/24/2025",
            attended: "No",
            desc: "Team gathering to celebrate the end of the Sprint.",
            event: "Sprint Party",
            eventType: "General Activity",
            period: "Sprint Break",
            scheduledDate: "04/24/2025",
          },
        ],
      },
    ],
    staff: [
      {
        staffId: 1,
        name: "Hooshyar",
        role: "Product Owner",
        getMemberTermAttendance: [
          {
            id: "1",
            actualDate: "03/11/2025",
            attended: "No",
            desc: "",
            event: "Story Point checking",
            eventType: "General Activity",
            period: "Applicants Submission",
            scheduledDate: "03/11/2025",
          },
          {
            id: "2",
            actualDate: "04/24/2025",
            attended: "No",
            desc: "Team gathering to celebrate the end of the Sprint.",
            event: "Sprint Party",
            eventType: "General Activity",
            period: "Sprint Break",
            scheduledDate: "04/24/2025",
          },
        ],
      },
      {
        staffId: 2,
        name: "Sandy",
        role: "Scrum Master",
        getMemberTermAttendance: [
          {
            id: "1",
            actualDate: "03/11/2025",
            attended: "No",
            desc: "",
            event: "Story Point checking",
            eventType: "General Activity",
            period: "Applicants Submission",
            scheduledDate: "03/11/2025",
          },
          {
            id: "2",
            actualDate: "04/24/2025",
            attended: "No",
            desc: "Team gathering to celebrate the end of the Sprint.",
            event: "Sprint Party",
            eventType: "General Activity",
            period: "Sprint Break",
            scheduledDate: "04/24/2025",
          },
        ],
      },
      {
        staffId: 3,
        name: "David",
        role: "Developer",
        getMemberTermAttendance: [
          {
            id: "1",
            actualDate: "03/11/2025",
            attended: "No",
            desc: "",
            event: "Story Point checking",
            eventType: "General Activity",
            period: "Applicants Submission",
            scheduledDate: "03/11/2025",
          },
          {
            id: "2",
            actualDate: "04/24/2025",
            attended: "No",
            desc: "Team gathering to celebrate the end of the Sprint.",
            event: "Sprint Party",
            eventType: "General Activity",
            period: "Sprint Break",
            scheduledDate: "04/24/2025",
          },
        ],
      },
      {
        staffId: 4,
        name: "Rose",
        role: "Scrum Master",
        getMemberTermAttendance: [
          {
            id: "1",
            actualDate: "03/11/2025",
            attended: "No",
            desc: "",
            event: "Story Point checking",
            eventType: "General Activity",
            period: "Applicants Submission",
            scheduledDate: "03/11/2025",
          },
          {
            id: "2",
            actualDate: "04/24/2025",
            attended: "No",
            desc: "Team gathering to celebrate the end of the Sprint.",
            event: "Sprint Party",
            eventType: "General Activity",
            period: "Sprint Break",
            scheduledDate: "04/24/2025",
          },
        ],
      },
      {
        staffId: 5,
        name: "Robinia",
        role: "Developer",
        getMemberTermAttendance: [
          {
            id: "1",
            actualDate: "03/11/2025",
            attended: "No",
            desc: "",
            event: "Story Point checking",
            eventType: "General Activity",
            period: "Applicants Submission",
            scheduledDate: "03/11/2025",
          },
          {
            id: "2",
            actualDate: "04/24/2025",
            attended: "No",
            desc: "Team gathering to celebrate the end of the Sprint.",
            event: "Sprint Party",
            eventType: "General Activity",
            period: "Sprint Break",
            scheduledDate: "04/24/2025",
          },
        ],
      },
    ],
  },
  {
    teamId: 9,
    members: [
      {
        memberId: 1,
        name: "David Johnson",
        role: "Product Owner",
        getMemberTermAttendance: [
          {
            id: "1",
            actualDate: "03/11/2025",
            attended: "No",
            desc: "",
            event: "Story Point checking",
            eventType: "General Activity",
            period: "Applicants Submission",
            scheduledDate: "03/11/2025",
          },
          {
            id: "2",
            actualDate: "04/24/2025",
            attended: "No",
            desc: "Team gathering to celebrate the end of the Sprint.",
            event: "Sprint Party",
            eventType: "General Activity",
            period: "Sprint Break",
            scheduledDate: "04/24/2025",
          },
        ],
      },
      {
        memberId: 2,
        name: "Susan Sanders",
        role: "Developer",
        getMemberTermAttendance: [
          {
            id: "1",
            actualDate: "03/11/2025",
            attended: "No",
            desc: "",
            event: "Story Point checking",
            eventType: "General Activity",
            period: "Applicants Submission",
            scheduledDate: "03/11/2025",
          },
          {
            id: "2",
            actualDate: "04/24/2025",
            attended: "No",
            desc: "Team gathering to celebrate the end of the Sprint.",
            event: "Sprint Party",
            eventType: "General Activity",
            period: "Sprint Break",
            scheduledDate: "04/24/2025",
          },
        ],
      },
      {
        memberId: 3,
        name: "Mary Smith",
        role: "Developer",
        getMemberTermAttendance: [
          {
            id: "1",
            actualDate: "03/11/2025",
            attended: "No",
            desc: "",
            event: "Story Point checking",
            eventType: "General Activity",
            period: "Applicants Submission",
            scheduledDate: "03/11/2025",
          },
          {
            id: "2",
            actualDate: "04/24/2025",
            attended: "No",
            desc: "Team gathering to celebrate the end of the Sprint.",
            event: "Sprint Party",
            eventType: "General Activity",
            period: "Sprint Break",
            scheduledDate: "04/24/2025",
          },
        ],
      },
      {
        memberId: 4,
        name: "Don Song",
        role: "Product Owner",
        getMemberTermAttendance: [
          {
            id: "1",
            actualDate: "03/11/2025",
            attended: "No",
            desc: "",
            event: "Story Point checking",
            eventType: "General Activity",
            period: "Applicants Submission",
            scheduledDate: "03/11/2025",
          },
          {
            id: "2",
            actualDate: "04/24/2025",
            attended: "No",
            desc: "Team gathering to celebrate the end of the Sprint.",
            event: "Sprint Party",
            eventType: "General Activity",
            period: "Sprint Break",
            scheduledDate: "04/24/2025",
          },
        ],
      },
      {
        memberId: 5,
        name: "Joseph Foo",
        role: "Scrum Master",
        getMemberTermAttendance: [
          {
            id: "1",
            actualDate: "03/11/2025",
            attended: "No",
            desc: "",
            event: "Story Point checking",
            eventType: "General Activity",
            period: "Applicants Submission",
            scheduledDate: "03/11/2025",
          },
          {
            id: "2",
            actualDate: "04/24/2025",
            attended: "No",
            desc: "Team gathering to celebrate the end of the Sprint.",
            event: "Sprint Party",
            eventType: "General Activity",
            period: "Sprint Break",
            scheduledDate: "04/24/2025",
          },
        ],
      },
    ],
    staff: [
      {
        staffId: 1,
        name: "Hooshyar",
        role: "Product Owner",
        getMemberTermAttendance: [
          {
            id: "1",
            actualDate: "03/11/2025",
            attended: "No",
            desc: "",
            event: "Story Point checking",
            eventType: "General Activity",
            period: "Applicants Submission",
            scheduledDate: "03/11/2025",
          },
          {
            id: "2",
            actualDate: "04/24/2025",
            attended: "No",
            desc: "Team gathering to celebrate the end of the Sprint.",
            event: "Sprint Party",
            eventType: "General Activity",
            period: "Sprint Break",
            scheduledDate: "04/24/2025",
          },
        ],
      },
      {
        staffId: 2,
        name: "Sandy",
        role: "Scrum Master",
        getMemberTermAttendance: [
          {
            id: "1",
            actualDate: "03/11/2025",
            attended: "No",
            desc: "",
            event: "Story Point checking",
            eventType: "General Activity",
            period: "Applicants Submission",
            scheduledDate: "03/11/2025",
          },
          {
            id: "2",
            actualDate: "04/24/2025",
            attended: "No",
            desc: "Team gathering to celebrate the end of the Sprint.",
            event: "Sprint Party",
            eventType: "General Activity",
            period: "Sprint Break",
            scheduledDate: "04/24/2025",
          },
        ],
      },
      {
        staffId: 3,
        name: "David",
        role: "Developer",
        getMemberTermAttendance: [
          {
            id: "1",
            actualDate: "03/11/2025",
            attended: "No",
            desc: "",
            event: "Story Point checking",
            eventType: "General Activity",
            period: "Applicants Submission",
            scheduledDate: "03/11/2025",
          },
          {
            id: "2",
            actualDate: "04/24/2025",
            attended: "No",
            desc: "Team gathering to celebrate the end of the Sprint.",
            event: "Sprint Party",
            eventType: "General Activity",
            period: "Sprint Break",
            scheduledDate: "04/24/2025",
          },
        ],
      },
      {
        staffId: 4,
        name: "Rose",
        role: "Scrum Master",
        getMemberTermAttendance: [
          {
            id: "1",
            actualDate: "03/11/2025",
            attended: "No",
            desc: "",
            event: "Story Point checking",
            eventType: "General Activity",
            period: "Applicants Submission",
            scheduledDate: "03/11/2025",
          },
          {
            id: "2",
            actualDate: "04/24/2025",
            attended: "No",
            desc: "Team gathering to celebrate the end of the Sprint.",
            event: "Sprint Party",
            eventType: "General Activity",
            period: "Sprint Break",
            scheduledDate: "04/24/2025",
          },
        ],
      },
      {
        staffId: 5,
        name: "Robinia",
        role: "Developer",
        getMemberTermAttendance: [
          {
            id: "1",
            actualDate: "03/11/2025",
            attended: "No",
            desc: "",
            event: "Story Point checking",
            eventType: "General Activity",
            period: "Applicants Submission",
            scheduledDate: "03/11/2025",
          },
          {
            id: "2",
            actualDate: "04/24/2025",
            attended: "No",
            desc: "Team gathering to celebrate the end of the Sprint.",
            event: "Sprint Party",
            eventType: "General Activity",
            period: "Sprint Break",
            scheduledDate: "04/24/2025",
          },
        ],
      },
    ],
  },
  {
    teamId: 10,
    members: [
      {
        memberId: 1,
        name: "David Johnson",
        role: "Product Owner",
        getMemberTermAttendance: [
          {
            id: "1",
            actualDate: "03/11/2025",
            attended: "No",
            desc: "",
            event: "Story Point checking",
            eventType: "General Activity",
            period: "Applicants Submission",
            scheduledDate: "03/11/2025",
          },
          {
            id: "2",
            actualDate: "04/24/2025",
            attended: "No",
            desc: "Team gathering to celebrate the end of the Sprint.",
            event: "Sprint Party",
            eventType: "General Activity",
            period: "Sprint Break",
            scheduledDate: "04/24/2025",
          },
        ],
      },
      {
        memberId: 2,
        name: "Susan Sanders",
        role: "Developer",
        getMemberTermAttendance: [
          {
            id: "1",
            actualDate: "03/11/2025",
            attended: "No",
            desc: "",
            event: "Story Point checking",
            eventType: "General Activity",
            period: "Applicants Submission",
            scheduledDate: "03/11/2025",
          },
          {
            id: "2",
            actualDate: "04/24/2025",
            attended: "No",
            desc: "Team gathering to celebrate the end of the Sprint.",
            event: "Sprint Party",
            eventType: "General Activity",
            period: "Sprint Break",
            scheduledDate: "04/24/2025",
          },
        ],
      },
      {
        memberId: 3,
        name: "Mary Smith",
        role: "Developer",
        getMemberTermAttendance: [
          {
            id: "1",
            actualDate: "03/11/2025",
            attended: "No",
            desc: "",
            event: "Story Point checking",
            eventType: "General Activity",
            period: "Applicants Submission",
            scheduledDate: "03/11/2025",
          },
          {
            id: "2",
            actualDate: "04/24/2025",
            attended: "No",
            desc: "Team gathering to celebrate the end of the Sprint.",
            event: "Sprint Party",
            eventType: "General Activity",
            period: "Sprint Break",
            scheduledDate: "04/24/2025",
          },
        ],
      },
      {
        memberId: 4,
        name: "Don Song",
        role: "Product Owner",
        getMemberTermAttendance: [
          {
            id: "1",
            actualDate: "03/11/2025",
            attended: "No",
            desc: "",
            event: "Story Point checking",
            eventType: "General Activity",
            period: "Applicants Submission",
            scheduledDate: "03/11/2025",
          },
          {
            id: "2",
            actualDate: "04/24/2025",
            attended: "No",
            desc: "Team gathering to celebrate the end of the Sprint.",
            event: "Sprint Party",
            eventType: "General Activity",
            period: "Sprint Break",
            scheduledDate: "04/24/2025",
          },
        ],
      },
      {
        memberId: 5,
        name: "Joseph Foo",
        role: "Scrum Master",
        getMemberTermAttendance: [
          {
            id: "1",
            actualDate: "03/11/2025",
            attended: "No",
            desc: "",
            event: "Story Point checking",
            eventType: "General Activity",
            period: "Applicants Submission",
            scheduledDate: "03/11/2025",
          },
          {
            id: "2",
            actualDate: "04/24/2025",
            attended: "No",
            desc: "Team gathering to celebrate the end of the Sprint.",
            event: "Sprint Party",
            eventType: "General Activity",
            period: "Sprint Break",
            scheduledDate: "04/24/2025",
          },
        ],
      },
    ],
    staff: [
      {
        staffId: 1,
        name: "Hooshyar",
        role: "Product Owner",
        getMemberTermAttendance: [
          {
            id: "1",
            actualDate: "03/11/2025",
            attended: "No",
            desc: "",
            event: "Story Point checking",
            eventType: "General Activity",
            period: "Applicants Submission",
            scheduledDate: "03/11/2025",
          },
          {
            id: "2",
            actualDate: "04/24/2025",
            attended: "No",
            desc: "Team gathering to celebrate the end of the Sprint.",
            event: "Sprint Party",
            eventType: "General Activity",
            period: "Sprint Break",
            scheduledDate: "04/24/2025",
          },
        ],
      },
      {
        staffId: 2,
        name: "Sandy",
        role: "Scrum Master",
        getMemberTermAttendance: [
          {
            id: "1",
            actualDate: "03/11/2025",
            attended: "No",
            desc: "",
            event: "Story Point checking",
            eventType: "General Activity",
            period: "Applicants Submission",
            scheduledDate: "03/11/2025",
          },
          {
            id: "2",
            actualDate: "04/24/2025",
            attended: "No",
            desc: "Team gathering to celebrate the end of the Sprint.",
            event: "Sprint Party",
            eventType: "General Activity",
            period: "Sprint Break",
            scheduledDate: "04/24/2025",
          },
        ],
      },
      {
        staffId: 3,
        name: "David",
        role: "Developer",
        getMemberTermAttendance: [
          {
            id: "1",
            actualDate: "03/11/2025",
            attended: "No",
            desc: "",
            event: "Story Point checking",
            eventType: "General Activity",
            period: "Applicants Submission",
            scheduledDate: "03/11/2025",
          },
          {
            id: "2",
            actualDate: "04/24/2025",
            attended: "No",
            desc: "Team gathering to celebrate the end of the Sprint.",
            event: "Sprint Party",
            eventType: "General Activity",
            period: "Sprint Break",
            scheduledDate: "04/24/2025",
          },
        ],
      },
      {
        staffId: 4,
        name: "Rose",
        role: "Scrum Master",
        getMemberTermAttendance: [
          {
            id: "1",
            actualDate: "03/11/2025",
            attended: "No",
            desc: "",
            event: "Story Point checking",
            eventType: "General Activity",
            period: "Applicants Submission",
            scheduledDate: "03/11/2025",
          },
          {
            id: "2",
            actualDate: "04/24/2025",
            attended: "No",
            desc: "Team gathering to celebrate the end of the Sprint.",
            event: "Sprint Party",
            eventType: "General Activity",
            period: "Sprint Break",
            scheduledDate: "04/24/2025",
          },
        ],
      },
      {
        staffId: 5,
        name: "Robinia",
        role: "Developer",
        getMemberTermAttendance: [
          {
            id: "1",
            actualDate: "03/11/2025",
            attended: "No",
            desc: "",
            event: "Story Point checking",
            eventType: "General Activity",
            period: "Applicants Submission",
            scheduledDate: "03/11/2025",
          },
          {
            id: "2",
            actualDate: "04/24/2025",
            attended: "No",
            desc: "Team gathering to celebrate the end of the Sprint.",
            event: "Sprint Party",
            eventType: "General Activity",
            period: "Sprint Break",
            scheduledDate: "04/24/2025",
          },
        ],
      },
    ],
  },
  {
    teamId: 11,
    members: [
      {
        memberId: 1,
        name: "David Johnson",
        role: "Product Owner",
        getMemberTermAttendance: [
          {
            id: "1",
            actualDate: "03/11/2025",
            attended: "No",
            desc: "",
            event: "Story Point checking",
            eventType: "General Activity",
            period: "Applicants Submission",
            scheduledDate: "03/11/2025",
          },
          {
            id: "2",
            actualDate: "04/24/2025",
            attended: "No",
            desc: "Team gathering to celebrate the end of the Sprint.",
            event: "Sprint Party",
            eventType: "General Activity",
            period: "Sprint Break",
            scheduledDate: "04/24/2025",
          },
        ],
      },
      {
        memberId: 2,
        name: "Susan Sanders",
        role: "Developer",
        getMemberTermAttendance: [
          {
            id: "1",
            actualDate: "03/11/2025",
            attended: "No",
            desc: "",
            event: "Story Point checking",
            eventType: "General Activity",
            period: "Applicants Submission",
            scheduledDate: "03/11/2025",
          },
          {
            id: "2",
            actualDate: "04/24/2025",
            attended: "No",
            desc: "Team gathering to celebrate the end of the Sprint.",
            event: "Sprint Party",
            eventType: "General Activity",
            period: "Sprint Break",
            scheduledDate: "04/24/2025",
          },
        ],
      },
      {
        memberId: 3,
        name: "Mary Smith",
        role: "Developer",
        getMemberTermAttendance: [
          {
            id: "1",
            actualDate: "03/11/2025",
            attended: "No",
            desc: "",
            event: "Story Point checking",
            eventType: "General Activity",
            period: "Applicants Submission",
            scheduledDate: "03/11/2025",
          },
          {
            id: "2",
            actualDate: "04/24/2025",
            attended: "No",
            desc: "Team gathering to celebrate the end of the Sprint.",
            event: "Sprint Party",
            eventType: "General Activity",
            period: "Sprint Break",
            scheduledDate: "04/24/2025",
          },
        ],
      },
      {
        memberId: 4,
        name: "Don Song",
        role: "Product Owner",
        getMemberTermAttendance: [
          {
            id: "1",
            actualDate: "03/11/2025",
            attended: "No",
            desc: "",
            event: "Story Point checking",
            eventType: "General Activity",
            period: "Applicants Submission",
            scheduledDate: "03/11/2025",
          },
          {
            id: "2",
            actualDate: "04/24/2025",
            attended: "No",
            desc: "Team gathering to celebrate the end of the Sprint.",
            event: "Sprint Party",
            eventType: "General Activity",
            period: "Sprint Break",
            scheduledDate: "04/24/2025",
          },
        ],
      },
      {
        memberId: 5,
        name: "Joseph Foo",
        role: "Scrum Master",
        getMemberTermAttendance: [
          {
            id: "1",
            actualDate: "03/11/2025",
            attended: "No",
            desc: "",
            event: "Story Point checking",
            eventType: "General Activity",
            period: "Applicants Submission",
            scheduledDate: "03/11/2025",
          },
          {
            id: "2",
            actualDate: "04/24/2025",
            attended: "No",
            desc: "Team gathering to celebrate the end of the Sprint.",
            event: "Sprint Party",
            eventType: "General Activity",
            period: "Sprint Break",
            scheduledDate: "04/24/2025",
          },
        ],
      },
    ],
    staff: [
      {
        staffId: 1,
        name: "Hooshyar",
        role: "Product Owner",
        getMemberTermAttendance: [
          {
            id: "1",
            actualDate: "03/11/2025",
            attended: "No",
            desc: "",
            event: "Story Point checking",
            eventType: "General Activity",
            period: "Applicants Submission",
            scheduledDate: "03/11/2025",
          },
          {
            id: "2",
            actualDate: "04/24/2025",
            attended: "No",
            desc: "Team gathering to celebrate the end of the Sprint.",
            event: "Sprint Party",
            eventType: "General Activity",
            period: "Sprint Break",
            scheduledDate: "04/24/2025",
          },
        ],
      },
      {
        staffId: 2,
        name: "Sandy",
        role: "Scrum Master",
        getMemberTermAttendance: [
          {
            id: "1",
            actualDate: "03/11/2025",
            attended: "No",
            desc: "",
            event: "Story Point checking",
            eventType: "General Activity",
            period: "Applicants Submission",
            scheduledDate: "03/11/2025",
          },
          {
            id: "2",
            actualDate: "04/24/2025",
            attended: "No",
            desc: "Team gathering to celebrate the end of the Sprint.",
            event: "Sprint Party",
            eventType: "General Activity",
            period: "Sprint Break",
            scheduledDate: "04/24/2025",
          },
        ],
      },
      {
        staffId: 3,
        name: "David",
        role: "Developer",
        getMemberTermAttendance: [
          {
            id: "1",
            actualDate: "03/11/2025",
            attended: "No",
            desc: "",
            event: "Story Point checking",
            eventType: "General Activity",
            period: "Applicants Submission",
            scheduledDate: "03/11/2025",
          },
          {
            id: "2",
            actualDate: "04/24/2025",
            attended: "No",
            desc: "Team gathering to celebrate the end of the Sprint.",
            event: "Sprint Party",
            eventType: "General Activity",
            period: "Sprint Break",
            scheduledDate: "04/24/2025",
          },
        ],
      },
      {
        staffId: 4,
        name: "Rose",
        role: "Scrum Master",
        getMemberTermAttendance: [
          {
            id: "1",
            actualDate: "03/11/2025",
            attended: "No",
            desc: "",
            event: "Story Point checking",
            eventType: "General Activity",
            period: "Applicants Submission",
            scheduledDate: "03/11/2025",
          },
          {
            id: "2",
            actualDate: "04/24/2025",
            attended: "No",
            desc: "Team gathering to celebrate the end of the Sprint.",
            event: "Sprint Party",
            eventType: "General Activity",
            period: "Sprint Break",
            scheduledDate: "04/24/2025",
          },
        ],
      },
      {
        staffId: 5,
        name: "Robinia",
        role: "Developer",
        getMemberTermAttendance: [
          {
            id: "1",
            actualDate: "03/11/2025",
            attended: "No",
            desc: "",
            event: "Story Point checking",
            eventType: "General Activity",
            period: "Applicants Submission",
            scheduledDate: "03/11/2025",
          },
          {
            id: "2",
            actualDate: "04/24/2025",
            attended: "No",
            desc: "Team gathering to celebrate the end of the Sprint.",
            event: "Sprint Party",
            eventType: "General Activity",
            period: "Sprint Break",
            scheduledDate: "04/24/2025",
          },
        ],
      },
    ],
  },
  {
    teamId: 12,
    members: [
      {
        memberId: 1,
        name: "David Johnson",
        role: "Product Owner",
        getMemberTermAttendance: [
          {
            id: "1",
            actualDate: "03/11/2025",
            attended: "No",
            desc: "",
            event: "Story Point checking",
            eventType: "General Activity",
            period: "Applicants Submission",
            scheduledDate: "03/11/2025",
          },
          {
            id: "2",
            actualDate: "04/24/2025",
            attended: "No",
            desc: "Team gathering to celebrate the end of the Sprint.",
            event: "Sprint Party",
            eventType: "General Activity",
            period: "Sprint Break",
            scheduledDate: "04/24/2025",
          },
        ],
      },
      {
        memberId: 2,
        name: "Susan Sanders",
        role: "Developer",
        getMemberTermAttendance: [
          {
            id: "1",
            actualDate: "03/11/2025",
            attended: "No",
            desc: "",
            event: "Story Point checking",
            eventType: "General Activity",
            period: "Applicants Submission",
            scheduledDate: "03/11/2025",
          },
          {
            id: "2",
            actualDate: "04/24/2025",
            attended: "No",
            desc: "Team gathering to celebrate the end of the Sprint.",
            event: "Sprint Party",
            eventType: "General Activity",
            period: "Sprint Break",
            scheduledDate: "04/24/2025",
          },
        ],
      },
      {
        memberId: 3,
        name: "Mary Smith",
        role: "Developer",
        getMemberTermAttendance: [
          {
            id: "1",
            actualDate: "03/11/2025",
            attended: "No",
            desc: "",
            event: "Story Point checking",
            eventType: "General Activity",
            period: "Applicants Submission",
            scheduledDate: "03/11/2025",
          },
          {
            id: "2",
            actualDate: "04/24/2025",
            attended: "No",
            desc: "Team gathering to celebrate the end of the Sprint.",
            event: "Sprint Party",
            eventType: "General Activity",
            period: "Sprint Break",
            scheduledDate: "04/24/2025",
          },
        ],
      },
      {
        memberId: 4,
        name: "Don Song",
        role: "Product Owner",
        getMemberTermAttendance: [
          {
            id: "1",
            actualDate: "03/11/2025",
            attended: "No",
            desc: "",
            event: "Story Point checking",
            eventType: "General Activity",
            period: "Applicants Submission",
            scheduledDate: "03/11/2025",
          },
          {
            id: "2",
            actualDate: "04/24/2025",
            attended: "No",
            desc: "Team gathering to celebrate the end of the Sprint.",
            event: "Sprint Party",
            eventType: "General Activity",
            period: "Sprint Break",
            scheduledDate: "04/24/2025",
          },
        ],
      },
      {
        memberId: 5,
        name: "Joseph Foo",
        role: "Scrum Master",
        getMemberTermAttendance: [
          {
            id: "1",
            actualDate: "03/11/2025",
            attended: "No",
            desc: "",
            event: "Story Point checking",
            eventType: "General Activity",
            period: "Applicants Submission",
            scheduledDate: "03/11/2025",
          },
          {
            id: "2",
            actualDate: "04/24/2025",
            attended: "No",
            desc: "Team gathering to celebrate the end of the Sprint.",
            event: "Sprint Party",
            eventType: "General Activity",
            period: "Sprint Break",
            scheduledDate: "04/24/2025",
          },
        ],
      },
    ],
    staff: [
      {
        staffId: 1,
        name: "Hooshyar",
        role: "Product Owner",
        getMemberTermAttendance: [
          {
            id: "1",
            actualDate: "03/11/2025",
            attended: "No",
            desc: "",
            event: "Story Point checking",
            eventType: "General Activity",
            period: "Applicants Submission",
            scheduledDate: "03/11/2025",
          },
          {
            id: "2",
            actualDate: "04/24/2025",
            attended: "No",
            desc: "Team gathering to celebrate the end of the Sprint.",
            event: "Sprint Party",
            eventType: "General Activity",
            period: "Sprint Break",
            scheduledDate: "04/24/2025",
          },
        ],
      },
      {
        staffId: 2,
        name: "Sandy",
        role: "Scrum Master",
        getMemberTermAttendance: [
          {
            id: "1",
            actualDate: "03/11/2025",
            attended: "No",
            desc: "",
            event: "Story Point checking",
            eventType: "General Activity",
            period: "Applicants Submission",
            scheduledDate: "03/11/2025",
          },
          {
            id: "2",
            actualDate: "04/24/2025",
            attended: "No",
            desc: "Team gathering to celebrate the end of the Sprint.",
            event: "Sprint Party",
            eventType: "General Activity",
            period: "Sprint Break",
            scheduledDate: "04/24/2025",
          },
        ],
      },
      {
        staffId: 3,
        name: "David",
        role: "Developer",
        getMemberTermAttendance: [
          {
            id: "1",
            actualDate: "03/11/2025",
            attended: "No",
            desc: "",
            event: "Story Point checking",
            eventType: "General Activity",
            period: "Applicants Submission",
            scheduledDate: "03/11/2025",
          },
          {
            id: "2",
            actualDate: "04/24/2025",
            attended: "No",
            desc: "Team gathering to celebrate the end of the Sprint.",
            event: "Sprint Party",
            eventType: "General Activity",
            period: "Sprint Break",
            scheduledDate: "04/24/2025",
          },
        ],
      },
      {
        staffId: 4,
        name: "Rose",
        role: "Scrum Master",
        getMemberTermAttendance: [
          {
            id: "1",
            actualDate: "03/11/2025",
            attended: "No",
            desc: "",
            event: "Story Point checking",
            eventType: "General Activity",
            period: "Applicants Submission",
            scheduledDate: "03/11/2025",
          },
          {
            id: "2",
            actualDate: "04/24/2025",
            attended: "No",
            desc: "Team gathering to celebrate the end of the Sprint.",
            event: "Sprint Party",
            eventType: "General Activity",
            period: "Sprint Break",
            scheduledDate: "04/24/2025",
          },
        ],
      },
      {
        staffId: 5,
        name: "Robinia",
        role: "Developer",
        getMemberTermAttendance: [
          {
            id: "1",
            actualDate: "03/11/2025",
            attended: "No",
            desc: "",
            event: "Story Point checking",
            eventType: "General Activity",
            period: "Applicants Submission",
            scheduledDate: "03/11/2025",
          },
          {
            id: "2",
            actualDate: "04/24/2025",
            attended: "No",
            desc: "Team gathering to celebrate the end of the Sprint.",
            event: "Sprint Party",
            eventType: "General Activity",
            period: "Sprint Break",
            scheduledDate: "04/24/2025",
          },
        ],
      },
    ],
  },
];
const datePart = now.toLocaleDateString("en-US", {
  month: "long",
  day: "numeric",
  year: "numeric",
});

const timePart = now.toLocaleTimeString("en-US", {
  hour: "numeric",
  minute: "2-digit",
  hour12: true,
});
function Tenant() {
  const [loadData, setLoadData] = useState(false);
  const [loadContent, setLoadContent] = useState(false);
  // static data
  const termUuid = "15e57b17-c41d-411c-a0e9-45b55117fd6f";
  const teamUuid = "489f4e45-c009-496d-bb96-f07ca41179b1";
  //
  const [termName, setTermName] = useState("");

  const [resourcesRow, setResourcesRow] = useState([]);
  const [periodDataList, setPeriodDataList] = useState([]);
  const [teamsList, setTeamsList] = useState([]);
  const [sprintStartDate, setSprintStartDate] = useState(null);
  const [sprintEndDate, setSprintEndDate] = useState(null);
  const [teamTermData, setTeamTermData] = useState([]);
  const [openActivitiesDialog, setOpenActivitiesDialog] = useState(null);
  const [openResourcesDialog, setOpenResourcesDialog] = useState(null);
  const [openAttendanceDialog, setOpenAttendanceDialog] = useState(null);
  const [activitiesRows, setActivitiesRows] = useState([]);

  const [getTermDataQuery] = useManualQuery(GET_TERM_DATA_BY_TERM_UUID);
  const [getTeamTermPeriodsQuery] = useManualQuery(TEAM_TERM_ALL_PERIODS_QUERY);
  const [getTeamTermDataQuery] = useManualQuery(GET_TEAM_DATA_BY_UUID);
  const [fetchAllTeams] = useManualQuery(GET_ALL_TEAMS_QUERY);
  const [fetchAllTeamTermResources] = useManualQuery(
    GET_ALL_MEMBERS_IN_TEAM_TERM_QUERY
  );

  const client = useContext(ClientContext);
  const [pathname] = useState(window.location.pathname);

  const [refreshToken] = useMutation(REFRESH_TOKEN_MUTATION, {
    onError: (err) => {
      console.log(err);
    },
  });
  let clientId = 0;
  if (localStorage.getItem("clientId"))
    clientId = localStorage.getItem("clientId");

  useEffect(() => {
    window.scrollTo(0, 0);
    if (localStorage.getItem("refreshToken")) {
      onRefreshToken();
    } else window.location.href = `${project_url}/signin/?next=${pathname}`;
  }, []);
  useEffect(() => {
    (() => getTermData())();
  }, [teamTermData]);

  useEffect(() => {
    (() => getResourcesRow())();
  }, [teamsList]);

  useEffect(() => {
    (() => getTeamTermData())();
  }, []);
  useEffect(() => {
    (() => getTeamsList())();
  }, []);
  useEffect(() => {
    setActivitiesRows(flattenRows(periodDataList));
  }, [periodDataList]);

  const onRefreshToken = async () => {
    const { data: refreshData, error: refreshError } = await refreshToken({
      variables: { refreshToken: localStorage.getItem("refreshToken") },
    });
    if (refreshError) {
      if (
        refreshError.graphQLErrors[0].message ===
        "You do not have permission to perform this action"
      )
        window.location.href = `${project_url}/signin/?next=${pathname}`;
      if (refreshError.graphQLErrors[0].message === "Signature has expired")
        window.location.href = `${project_url}/signin/?next=${pathname}`;
    }
    if (refreshData && refreshData.refreshToken) {
      localStorage.setItem("token", refreshData.refreshToken.token);
      localStorage.setItem(
        "refreshToken",
        refreshData.refreshToken.refreshToken
      );
      client.setHeader(
        "Authorization",
        `JWT ${refreshData.refreshToken.token}`
      );
      setLoadContent(true);
      setLoadData(true);
    }
  };

  const classes = useStyles();
  const getTeamsList = async () => {
    const {
      loading: teamsListLoading,
      error: teamsListError,
      data: teamsListData,
    } = await fetchAllTeams({
      variables: {
        clientId: parseInt(clientId),
      },
    });
    if (!teamsListLoading && teamsListData && teamsListData.allTeams) {
      let rows = [];
      teamsListData.allTeams.map((team) => {
        let row = [];
        const findRow = resourcesData.find((r) => {
          return r.teamId === parseInt(team.teamId);
        });

        row["teamId"] = team.teamId;
        row["name"] = team.name;
        row["desc"] = team.desc;
        row["teamTermId"] = "21"; //static data for ui
        row["members"] = findRow.members;
        row["staff"] = findRow.staff;
        row["noOfResources"] = findRow
          ? findRow.members.length + findRow.staff.length
          : "";
        rows.push(row);
      });
      setTeamsList(rows);
    }
  };
  const getTermData = async () => {
    const {
      loading: loadingTermData,
      error: errorTermData,
      data: dataTermData,
    } = await getTermDataQuery({
      variables: {
        termUuid: termUuid,
      },
    });
    if (
      !loadingTermData &&
      dataTermData &&
      dataTermData.getTermDataByTermUuid
    ) {
      setTermName(dataTermData.getTermDataByTermUuid.name);
      setSprintStartDate(
        new Date(
          dataTermData.getTermDataByTermUuid.startDate
        ).toLocaleDateString("sv-SE")
      );
      getTeamTermPeriods();
    }
  };
  const getTeamTermData = async () => {
    if (teamUuid && termUuid) {
      const {
        loading: loadingTeamTermData,
        error: errorTeamTermData,
        data: dataTeamTermData,
      } = await getTeamTermDataQuery({
        variables: {
          teamUuid: teamUuid,
          termUuid: termUuid,
        },
      });

      if (
        !loadingTeamTermData &&
        dataTeamTermData &&
        dataTeamTermData.getTeamTermData
      ) {
        setTeamTermData(dataTeamTermData.getTeamTermData);
      }
    }
  };
  const getTeamTermPeriods = async () => {
    if (teamTermData.teamTermId) {
      const {
        loading: loadingTeamTermPeriods,
        error: errorTeamTermPeriods,
        data: dataTeamTermPeriods,
      } = await getTeamTermPeriodsQuery({
        variables: {
          teamTermId: parseInt(teamTermData.teamTermId),
        },
      });
      if (
        !loadingTeamTermPeriods &&
        dataTeamTermPeriods &&
        dataTeamTermPeriods.teamTermAllPeriodList
      ) {
        const inSprintFiltered = dataTeamTermPeriods.teamTermAllPeriodList.filter(
          (period) => {
            return period.inSprint;
          }
        );

        setPeriodDataList(inSprintFiltered);
        setLoadData(true);

        if (dataTeamTermPeriods.teamTermAllPeriodList.length > 0) {
          const lastPeriodEndDate = new Date(
            dataTeamTermPeriods.teamTermAllPeriodList.slice(-1)[0].endDate
          );
          setSprintEndDate(lastPeriodEndDate.toLocaleDateString("sv-SE"));
        }
      }
    }
  };
  const getResourcesRow = () => {
    let members = 0;
    let staff = 0;
    let rows = [];
    teamsList.map((t) => {
      members += t.members.length;
      staff += t.staff.length;
    });
    rows.push({ id: 1, resources: "Members", noOfResources: members });
    rows.push({ id: 2, resources: "Staff", noOfResources: staff });
    setResourcesRow(rows);
  };
  const getResourcesData = (teamId, name) => {
    const findRow = resourcesData.find((r) => {
      return r.teamId === parseInt(teamId);
    });
    setOpenResourcesDialog({
      members: findRow ? findRow.members : [],
      staff: findRow ? findRow.staff : [],
      name,
    });
  };
  const flattenRows2 = (data) => {
    let rowId = 1;
    let eventRows = [];
    if (data.length === 0) return [];
    data.forEach((period, index) => {
      if (period.teamTermEvents.length > 0 && period.inSprint) {
        period.teamTermEvents.forEach((event, index) => {
          if (event.attendanceRequired) {
            eventRows.push({
              id: rowId++,
              teamTermPeriodId: period.teamTermPeriodId,
              period: period.name,
              startDate: period.startDate,
              endDate: period.endDate,
              event: event.name,
              desc: event.desc,
              eventType: event.eventType,
              teamTermEventId: event.teamTermEventId,
              desc: event.desc,
              scheduledDate: event.scheduledDate,
              actualDate: event.actualDate,
              attendanceRequired: event.attendanceRequired,
            });
          }
        });
      }
    });
    return eventRows;
  };
  const getAttendanceData = async (teamId, name, teamTermId) => {
    let teamTermPeriodsEventsData = [];
    let members = [];
    let staff = [];
    if (teamTermId) {
      const {
        loading: teamTermPeriodsLoading,
        error: teamTermPeriodsError,
        data: teamTermPeriodsData,
      } = await getTeamTermPeriodsQuery({
        variables: {
          teamTermId: parseInt(teamTermId),
        },
      });

      if (
        !teamTermPeriodsLoading &&
        teamTermPeriodsData &&
        teamTermPeriodsData.teamTermAllPeriodList
      )
        teamTermPeriodsEventsData = flattenRows2(
          teamTermPeriodsData.teamTermAllPeriodList
        );

      const {
        loading: teamTermResourcesLoading,
        error: teamTermResourcesError,
        data: teamTermResourcesData,
      } = await fetchAllTeamTermResources({
        variables: {
          teamTermId: parseInt(teamTermId),
        },
      });

      if (
        !teamTermResourcesLoading &&
        teamTermResourcesData &&
        teamTermResourcesData.getAllMembersInTeamTerm
      ) {
        members = teamTermResourcesData.getAllMembersInTeamTerm.filter(
          (item) => item.userTypeId.typeName === "Member"
        );
        staff = teamTermResourcesData.getAllMembersInTeamTerm.filter(
          (item) => item.userTypeId.typeName === "Staff"
        );
      }
    }
    setOpenAttendanceDialog({
      members: members,
      staff: staff,
      periodRows: teamTermPeriodsEventsData,
      name,
      teamTermId,
    });
  };

  const periodColumns = [
    {
      field: "name",
      headerName: "Period Name",
      minWidth: 150,
      flex: 1,
      disableColumnMenu: true,
    },
    {
      field: "startDate",
      headerName: "Start Date",
      minWidth: 100,
      flex: 1,
      // sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
    },
    {
      field: "endDate",
      headerName: "End Date",
      minWidth: 100,
      flex: 1,
      // sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
    },
  ];
  const resourcesColumns = [
    {
      field: "resources",
      headerName: "Resources",
      minWidth: 150,
      flex: 1,
      disableColumnMenu: true,
    },
    {
      field: "noOfResources",
      headerName: "No of Resources",
      minWidth: 100,
      flex: 1,
      // sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
    },
  ];
  const teamsColumns = [
    {
      field: "name",
      headerName: "Team Name",
      minWidth: 170,
      //  flex: 1,
      disableColumnMenu: true,
    },
    {
      field: "desc",
      headerName: "Description",
      minWidth: 200,
      flex: 1,
      disableColumnMenu: true,
    },
  ];
  const activitiesColumns = [
    {
      field: "period",
      headerName: "Period",
      headerClassName: "super-app-theme--header",
      minWidth: 130,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        if (params.row.period) {
          return (
            <Typography variant="h2" style={{ paddingTop: 10 }}>
              {params.row.period}
            </Typography>
          );
        } else if (params.row.startDate && params.row.endDate)
          return (
            <Box>
              <Typography variant="h5" className="row-span-empty">
                <b>Start Date:&nbsp;</b>
                {params.row.startDate}
              </Typography>
              <Typography variant="h5" className="row-span-empty">
                <b>End Date:&nbsp;</b>
                {params.row.endDate}
              </Typography>
            </Box>
          );
        return <span className="row-span-empty"></span>;
      },
    },
    {
      field: "event",
      headerClassName: "super-app-theme--header",
      headerName: "Event",
      minWidth: 150,
      sortable: false,
      flex: 1,
      disableColumnMenu: true,
      renderCell: (params) => {
        return <div>{params.value}</div>;
      },
    },
    {
      field: "desc",
      headerName: "Description",
      headerClassName: "super-app-theme--header",
      minWidth: 220,
      sortable: false,
      align: "center",
      flex: 1,
      headerAlign: "center",
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <div
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              width: "100%",
            }}
          >
            {params.value}
          </div>
        );
      },
    },
    {
      field: "scheduledDate",
      headerName: "Scheduled Date",
      headerClassName: "super-app-theme--header",
      minWidth: 170,
      sortable: false,
      align: "center",
      //  flex: 1,
      headerAlign: "center",
      disableColumnMenu: true,
      renderCell: (params) => {
        return <div>{params.value}</div>;
      },
    },
    {
      field: "actualDate",
      headerClassName: "super-app-theme--header",
      headerName: "Actual Date",
      minWidth: 150,
      sortable: false,
      align: "center",
      //  flex: 1,
      headerAlign: "center",
      disableColumnMenu: true,
      renderCell: (params) => {
        return <div>{params.value}</div>;
      },
    },
  ];
  const attendanceColumns = [
    {
      field: "period",
      headerClassName: "super-app-theme--header",
      headerName: "Period",
      minWidth: 150,
      flex: 1,
      sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
    },

    {
      field: "event",
      headerName: "Event",
      headerClassName: "super-app-theme--header",
      minWidth: 150,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
    },

    {
      field: "eventType",
      headerName: "Event Type",
      headerClassName: "super-app-theme--header",
      minWidth: 150,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
    },

    {
      field: "description",
      headerName: "Description",
      headerClassName: "super-app-theme--header",
      minWidth: 150,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
    },

    {
      field: "scheduledDate",
      headerClassName: "super-app-theme--header",
      headerName: "Scheduled Date",
      minWidth: 100,
      flex: 1,
      sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
    },

    {
      field: "actualDate",
      headerClassName: "super-app-theme--header",
      headerName: "Actual Date",
      minWidth: 100,
      flex: 1,
      sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
    },

    {
      field: "attended",
      headerClassName: "super-app-theme--header",
      headerName: "Resources Attended?",
      minWidth: 100,
      flex: 1,
      // sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
    },
  ];

  const flattenRows = (data) => {
    let rowId = 1;
    let eventRows = [];
    if (data.length === 0) return [];
    data.forEach((period, index) => {
      if (period.teamTermEvents.length > 0 && period.inSprint) {
        period.teamTermEvents.forEach((event, index) => {
          eventRows.push({
            id: rowId++,
            teamTermPeriodId: period.teamTermPeriodId,
            period: index === 0 ? period.name : null, // Only show in the first row
            startDate: index === 1 ? period.startDate : null, // Only show in the secound row
            endDate: index === 1 ? period.endDate : null,
            event: event.name,
            desc: event.desc,
            eventType: event.eventType,
            teamTermEventId: event.teamTermEventId,
            desc: event.desc,
            scheduledDate: event.scheduledDate,
            actualDate: event.actualDate,
            attendanceRequired: event.attendanceRequired,
          });
        });
      }
      // For the case that there is not any event under period
      if (period.teamTermEvents.length === 0 && period.inSprint) {
        eventRows.push({
          id: rowId++,
          teamTermPeriodId: null,
          period: period.name,
          startDate: null,
          endDate: null,
          dateRange: null,
          event: null,
          desc: null,
          scheduledDate: "",
          actualDate: "",
        });
      }
    });
    return eventRows;
  };
  function DataGridTitle() {
    return (
      <Box pt={1}>
        <Typography variant="h1" style={{ fontSize: 18, paddingBottom: 6 }}>
          Periods
        </Typography>
        <Divider />
      </Box>
    );
  }
  function ResourcesTitle() {
    return (
      <Box pt={1}>
        <Typography variant="h1" style={{ fontSize: 18, paddingBottom: 6 }}>
          Resources
        </Typography>
        <Divider />
      </Box>
    );
  }
  function TeamsTitle() {
    return (
      <Box pt={1}>
        <Typography variant="h1" style={{ fontSize: 18, paddingBottom: 6 }}>
          Teams
        </Typography>
        <Divider />
      </Box>
    );
  }
  const customFooter = () => {
    let count = 0;
    resourcesRow.map((r) => {
      if (parseInt(r.noOfResources)) count += r.noOfResources;
    });
    return (
      <Grid container className={classes.dataGridFooterStyle}>
        <Grid item xs={6}>
          <Typography
            className={classes.dataGridFooterTextStyle}
            style={{ textAlign: "left", paddingLeft: 10 }}
          >
            Total
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography
            style={{ textAlign: "center" }}
            className={classes.dataGridFooterTextStyle}
          >
            {count}
          </Typography>
        </Grid>
      </Grid>
    );
  };
  if (loadContent && loadData)
    return (
      <div className={classes.root}>
        <Header breadcrumbs={[{ label: "Dashboard", link: null }]} />
        <div className={classes.container}>
          <Box mt={2} mb={2} textAlign="center">
            <Typography
              variant="body1"
              style={{ marginBottom: 10, fontWeight: 600 }}
            >
              Dashboard
            </Typography>
          </Box>
          <Divider />
          <Grid container style={{ paddingTop: 20 }}>
            <Grid
              item
              xs={12}
              style={{
                display: "flex",
                justifyContent: "flex-end",
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              <Typography style={{ paddingRight: 5 }} variant="h3">
                <strong>Today's Date:</strong> {datePart} - {timePart}
              </Typography>
            </Grid>
            <Grid container style={{ paddingTop: 20 }}>
              <Grid
                item
                xs={5}
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <Typography style={{ paddingRight: 5 }} variant="h2">
                  Current Sprint:
                </Typography>
                <Typography variant="h3">Term-2 by HFN</Typography>
              </Grid>
              <Grid
                item
                xs={6}
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  paddingLeft: 65,
                }}
              >
                <Typography style={{ paddingRight: 5 }} variant="h2">
                  No of Seats:
                </Typography>

                <Typography variant="h3">5</Typography>
              </Grid>
              <Grid
                item
                xs={5}
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <Typography style={{ paddingRight: 5 }} variant="h2">
                  Start Date:
                </Typography>
                <Typography variant="h3">March 23, 2025</Typography>
              </Grid>
              <Grid
                item
                xs={6}
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  paddingLeft: 65,
                }}
              >
                <Typography style={{ paddingRight: 5 }} variant="h2">
                  No of Applicants:
                </Typography>

                <Typography variant="h3">17</Typography>
              </Grid>
              <Grid
                item
                xs={5}
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <Typography style={{ paddingRight: 5 }} variant="h2">
                  End Date:
                </Typography>
                <Typography variant="h3">April 26, 2025</Typography>
              </Grid>
              <Grid
                item
                xs={6}
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  paddingLeft: 65,
                }}
              >
                <Typography style={{ paddingRight: 5 }} variant="h2">
                  No of Teams:
                </Typography>

                <Typography variant="h3">{teamsList.length}</Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid
            container
            spacing={3}
            style={{
              display: "flex",
              flexDirection: "row",
            }}
          >
            <Grid item md={5}>
              <Box pt={4}>
                <DataGrid
                  className={classes.dataGridStyle}
                  columns={periodColumns}
                  rows={periodDataList}
                  showCellRightBorder={true}
                  hideFooter={true}
                  autoWidth={true}
                  autoHeight={true}
                  slots={{
                    toolbar: DataGridTitle,
                  }}
                  rowHeight={40}
                  getRowId={(row) => row.teamTermPeriodId}
                />
              </Box>
            </Grid>
            <Grid item md={3}>
              <Box pt={4}>
                <DataGrid
                  className={classes.dataGridStyle}
                  columns={resourcesColumns}
                  rows={resourcesRow}
                  showCellRightBorder={true}
                  //  hideFooter={true}
                  autoWidth={true}
                  autoHeight={true}
                  slots={{
                    toolbar: ResourcesTitle,
                    footer: customFooter,
                  }}
                  hideFooterSelectedRowCount
                  rowHeight={40}
                  getRowId={(row) => row.id}
                />
              </Box>
            </Grid>
            <Grid item md={4}>
              <Box pt={4}>
                <DataGrid
                  className={classes.dataGridStyle}
                  columns={teamsColumns}
                  rows={teamsList}
                  showCellRightBorder={true}
                  hideFooter={true}
                  autoWidth={true}
                  autoHeight={true}
                  slots={{
                    toolbar: TeamsTitle,
                  }}
                  rowHeight={40}
                  getRowId={(row) => row.teamId}
                />
              </Box>
            </Grid>
          </Grid>
          <Typography
            variant="body1"
            gutterBottom
            style={{
              paddingTop: 10,
            }}
          >
            <b>Teams</b>
          </Typography>
          <Box pt={3} pb={5} sx={{ flexGrow: 1 }}>
            <Grid container spacing={3}>
              {teamsList.map((team) => (
                <Grid item md={4} key={team.teamId}>
                  <Card sx={{ height: "100%" }} className={classes.card}>
                    <Typography
                      variant="h3"
                      gutterBottom
                      style={{
                        paddingTop: 10,
                        paddingBottom: 5,
                        paddingLeft: 20,
                        paddingRight: 20,
                        textAlign: "center",
                      }}
                    >
                      {team.name}
                    </Typography>
                    <Divider />
                    <Typography
                      variant="h3"
                      style={{
                        paddingTop: 10,
                        paddingBottom: 10,
                        paddingLeft: 20,
                        paddingRight: 20,
                      }}
                    >
                      <b>Members:</b>&nbsp; {team.members.length}
                    </Typography>
                    <Typography
                      variant="h3"
                      style={{
                        paddingBottom: 10,
                        paddingLeft: 20,
                        paddingRight: 20,
                      }}
                    >
                      <b>Staff:</b>&nbsp; {team.staff.length}
                    </Typography>
                    <Box pl={2} pr={1}>
                      <Grid container spacing={3}>
                        <Grid
                          item
                          md={4}
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                          }}
                        >
                          <IconButton style={{ padding: 0 }}>
                            <CalendarMonthOutlinedIcon
                              onClick={() => setOpenActivitiesDialog(team.name)}
                            />
                          </IconButton>
                          <Typography
                            variant="h3"
                            style={{
                              paddingLeft: 5,
                            }}
                          >
                            <Link
                              href="/"
                              underline="none"
                              sx={{ color: "inherit" }}
                              onClick={(e) => {
                                e.preventDefault();
                                setOpenActivitiesDialog(team.name);
                              }}
                            >
                              Activites
                            </Link>
                          </Typography>
                        </Grid>
                        <Grid
                          item
                          md={4}
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                          }}
                        >
                          <IconButton style={{ padding: 0 }}>
                            <Diversity1Icon
                              onClick={() =>
                                getResourcesData(team.teamId, team.name)
                              }
                            />
                          </IconButton>
                          <Typography
                            variant="h3"
                            style={{
                              paddingLeft: 5,
                            }}
                          >
                            <Link
                              href="/"
                              underline="none"
                              sx={{ color: "inherit" }}
                              onClick={(e) => {
                                e.preventDefault();
                                getResourcesData(team.teamId, team.name);
                              }}
                            >
                              Resources
                            </Link>
                          </Typography>
                        </Grid>
                        <Grid
                          item
                          md={4}
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                          }}
                        >
                          <IconButton style={{ padding: 0 }}>
                            <HowToRegOutlinedIcon
                              onClick={() =>
                                getAttendanceData(
                                  team.teamId,
                                  team.name,
                                  team.teamTermId
                                )
                              }
                            />
                          </IconButton>
                          <Typography
                            variant="h3"
                            style={{
                              paddingLeft: 5,
                            }}
                          >
                            <Link
                              href="/"
                              underline="none"
                              sx={{ color: "inherit" }}
                              onClick={(e) => {
                                e.preventDefault();
                                getAttendanceData(team.teamId, team.name,team.teamTermId);
                              }}
                            >
                              Attendance
                            </Link>
                          </Typography>
                        </Grid>
                      </Grid>
                    </Box>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </Box>
          {openActivitiesDialog && (
            <ActivitiesDialog
              name={openActivitiesDialog}
              columns={activitiesColumns}
              rows={activitiesRows} //this data must be according selected team row
              closeDialog={() => setOpenActivitiesDialog(false)}
            />
          )}
          {openResourcesDialog && (
            <ResourcesDialog
              name={openResourcesDialog.name}
              members={openResourcesDialog.members}
              staff={openResourcesDialog.staff}
              closeDialog={() => setOpenResourcesDialog(null)}
            />
          )}
          {openAttendanceDialog && (
            <MemberAttendanceInfoDialog
              teamTerm={openAttendanceDialog.name}
              membersList={openAttendanceDialog.members}
              staffList={openAttendanceDialog.staff}
              teamTermPeriodEvents={openAttendanceDialog.periodRows}
              closeDialog={() => setOpenAttendanceDialog(null)}
            />
          )}
        </div>
      </div>
    );
  else return;
}

export default Tenant;
